const ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>';

const TILES = {
  voyager: "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
};

export function addBaseLayer(map, L, style = "voyager") {
  return L.tileLayer(TILES[style], {
    attribution: ATTRIBUTION,
    subdomains: "abcd",
    maxZoom: 20,
  }).addTo(map);
}